import { createAction } from 'redux-actions';

import { NOTIFY_MESSAGE } from './type';

export const notifyMessageAction = createAction(NOTIFY_MESSAGE);
